<template>
  <div id="login">
    <div class="loginBox">
      <!-- 图 -->
      <!-- <div style="width: 16%;margin-top:10px ">
        <img src="@/assets/imgs/mylogo.jpg" style="width:100%">
      </div> -->
      <!-- 文字 -->
      <p
        style="font-size: 30px; font-weight: bold; color: #222; margin: 14px 0"
      >
      乐山知识产权数据分析平台
      </p>
      <!-- 框 -->
      <div id="loginBox">
        <p
          style="
            font-size: 18px;
            font-weight: bold;
            color: #1471d5;
            text-align: center;
            margin-bottom: 5%;
          "
        >
          欢迎登录
        </p>
        <el-input class="inputFont" placeholder="请输入账号" v-model="userid">
          <i
            slot="prefix"
            class="iconfont"
            style="
              color: #1471d5;
              line-height: 5.5vh;
              margin-left: 5px;
              font-size: 18px;
              border-right: 2px solid #ddd;
              padding-right: 8px;
            "
            >&#xe6e4;</i
          >
        </el-input>
        <el-input
          class="inputFont"
          placeholder="请输入登录密码"
          v-model="userpwd"
          type="password"
        >
          <i
            slot="prefix"
            class="iconfont"
            style="
              color: #1471d5;
              line-height: 5.5vh;
              margin-left: 5px;
              font-size: 18px;
              border-right: 2px solid #ddd;
              padding-right: 8px;
            "
            >&#xe6e5;</i
          >
        </el-input>
        <el-button type="primary" @click="loginUser">登录</el-button>
        <p style="font-size: 12px; color: #333; margin-top: 10px">
          开通ID或忘记密码请联系平台管理员
        </p>
      </div>
    </div>
    <div id="footer">
      <div>
        <!-- <p>主办单位：眉山市市场监督管理局   眉山市知识产权局</p>
        <p>地址：眉山市东坡区湖滨路中二段130号</p>
        <p>联系电话：028-38185332</p> -->
      </div>
      <div class="company-info">
        <p>技术支持：成都市卓睿科技有限公司</p>
        <p>联系电话：028-84168818-8502</p>
      </div>
    </div>
  </div>
</template>
<script>
// import { apiLogin } from '@/request/api.js'
import { Encrypt } from "@/plugins/crypto.js";
// import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      userid: "",
      userpwd: "",
    };
  },
  methods: {
    loginUser() {

      if (this.userid !== "" && this.userpwd !== "") {
        var data = {
          account: this.userid,
          // password: this.$md5(this.userpwd +'myfx'),

          // account: Encrypt(this.userid),
          password: Encrypt(this.userpwd),
          // token: this.$store.token,
        };
        var that = this;
        this.$get("/user/login", data)
          .then((res) => {

            if (res.status == 200) {
               
                // this.$store.commit("getUser");
              localStorage.setItem("token", res.data.token);
              localStorage.setItem("uName", res.data.user.name);
              localStorage.setItem("uid", res.data.user.id);
              localStorage.setItem("ptDay", res.data.user.ptDay);
              localStorage.setItem("tmDay", res.data.user.tmDay);
              localStorage.setItem("ptDayEnd", res.data.user.ptDayEnd);
              let ptType = res.data.user.ptType.split("");
              if (ptType.length == 1) {
                ptType = res.data.user.ptType.split("");
              } else if (ptType.length > 1) {
                ptType = res.data.user.ptType.split(";");
              }
              localStorage.setItem("ptType", JSON.stringify(ptType));

              let permission = res.data.permission;

              this.$store.state.FuncPermission = permission.filter(function (
                item,
                index,
                array
              ) {
                return item && item.pid == "02";
              });
              let  DataPermission = permission.filter(function (
                item,
                index,
                array
              ) {
                return item && item.pid == "01";
              });
              let regions=[]
              let regionIds = ["03", "05", "04", "06", "13", "07", "08", "09", "10", "11","12"];
              regionIds.forEach(idIndex=>{
                DataPermission.forEach(ele=>{
                  if(idIndex === ele.id){
                    regions.push(ele)
                  }
                })
              });
              this.$store.state.DataPermission = regions;
              localStorage.setItem(
                "FuncPermission",
                JSON.stringify(this.$store.state.FuncPermission)
              );
              localStorage.setItem(
                "DataPermission",
                JSON.stringify(this.$store.state.DataPermission)
              );
              this.$router.push({
                path: "/",
              });
            } else if (res.status == 417) {
              that.$message({ message: res.msg, type: "warning" });
              // console.log(res.msg)
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message({ message: "用户名或密码不能为空", type: "warning" });
      }
    },
    // 监听方法
    keyDown(e) {
      if (e.keyCode == 13) {
        this.loginUser();
      }
      // console.log(e)
    },
  },
  mounted() {
    // 监听按下回车事件
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>
<style>
@media (min-width: 1366px) {
  body {
    font-size: 15px;
  }
}
@media (min-width: 1920px) {
  body {
    font-size: 24px;
  }
}

/* #login .footer div */
#login {
  width: 100vw;
  height: 100vh;
  background: url("../assets/imgs/loginback.jpg") no-repeat;
  background-size: 100% 100%;
  position: relative;
  min-height: 766px;
  min-width: 1366px;
}
#login > .loginBox {
  width: 36vw;
  /* max-width: 642px; */
  min-width: 550px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -32vh;
  transform: translateX(-50%);
  padding: 0.6% 0 2.65% 0;
}
#login #footer {
  background: none;
  font-size: 16px;
  top: 90%;
  transform: translateX(-50%);
  width: 50vw;
  padding: 0;
  max-width: none;
  line-height: 4vh;
  left: 50%;
  position: absolute;
  min-width: 580px;
}

/* #login #footer div:first-child {
  width: 100%;
  color: #fff;
  display: flex;
  justify-content: space-between;
} */
.company-info {
  display: flex;
  color: #fff;
  justify-content: space-around;
}
/* .company-info > p {
  margin-left: 20px;
} */

/* #login #footer div:nth-child(2) {
  width: 100%;
  color: #fff;
  display: flex;
  justify-content: space-around;
} */
#login #loginBox {
  max-width: 501px;
  max-height: 339px;
  width: 70%;
  border: 1px solid #dddddd;
  border-radius: 7px;
  padding: 5% 7% 5% 7%;
}
#login .inputFont {
  font-size: 16px;
  /* width: 100% !important; */
  margin-bottom: 5%;
}
#login .el-input__inner {
  height: 5.5vh !important;
}

#login .el-input__icon {
  color: #1471d5;
  font-size: 16px;
}
#login .el-button--primary {
  background-color: #1471d5 !important;
  border-color: #1471d5 !important;
}
#login .el-button {
  font-size: 16px !important;
  width: 100% !important;
}
#login .el-button:hover {
  background: #0757ac !important;
}
#login .el-input--prefix .el-input__inner {
  padding-left: 50px;
}
</style>
